
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiters/ville/[slug]",
      function () {
        return require("private-next-pages/recruiters/ville/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiters/ville/[slug]"])
      });
    }
  